import { render } from "./CompatibilityMatrix.vue?vue&type=template&id=e542d834"
import script from "./CompatibilityMatrix.vue?vue&type=script&lang=js"
export * from "./CompatibilityMatrix.vue?vue&type=script&lang=js"

import "./CompatibilityMatrix.vue?vue&type=style&index=0&id=e542d834&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__